/**
 * Admin/AccountAccess Controller
 *
 * 
 */

// the constructor for this object
function AdminAccountAccessController() { }

// the object
AdminAccountAccessController.prototype = {
    constructor: AdminAccountAccessController,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of invoices per page
    perPage: 20,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // the user must be a USS admin to access this page
        PortalMain.ussAdminRedirect();
        
        // set up the pagination
        this._setupPagination();
        
        PortalHelper.debugMessage('Admin Account Access Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
    
        // register the events used by this controller
        this._registerEvents();
        
        // populate the search form
        PortalMain.AdminAccountAccessController._populateForm();
        
        PortalMain.AdminAccountAccessController._showPage();
        
        PortalHelper.debugMessage('Admin Account Access Controller Ran');
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#accounts-pagination';
        pagination.contentSelector = '#accounts-table';
        pagination.searchSelector = '#portal-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.AdminAccountAccessController._getAccounts;
        PortalMain.AdminAccountAccessController.pagination = pagination;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // change the users permission for an account
        $('#accounts-table').on('change', 'input[type="radio"]', function() {
            var accountId = $(this).closest('tr').attr('data-account-id');
            var accessLevel = $(this).val();
            PortalMain.AdminAccountAccessController._updateAccountPermission(accountId, accessLevel);
        });
        
        // clear all accounts for the user
        $('#clear-accounts').on('click', function() {
            PortalMain.AdminAccountAccessController._clearAccounts();
        });
    },
    
    // fill in the search form
    _populateForm: function()
    {
        var user = PortalMain.PortalToken.getPayload();
        $('#search-user').val(user.user_id);
        
    },
    
    // show the admin page
    _showPage: function()
    {
        var user = PortalMain.PortalToken.getPayload();
        if (user.uss_admin_level >= 1) {
            PortalHelper.loadingOverlay('.content-col__content', false);
        }
    },
    
    // get the accounts from the api
    _getAccounts: function()
    {   
        $('#no-accounts').addClass('hidden');
        $('#clear-accounts-success').addClass('hidden');
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.AdminAccountAccessController.pagination.getBaseSubmissionData();
        
        // include the search user id
        if ($('#search-user:checked').val()) {
            submissionData.search_user = $('#search-user:checked').val();
        }
        
        // make the request
        var invoicesRequest = new PortalRequest;
        invoicesRequest.pageNumber = submissionData.page;
        invoicesRequest.makeRequest(
            '/admin/find-accounts',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.AdminAccountAccessController.pagination.updatePagination(data);
                PortalMain.AdminAccountAccessController.pagination.showPagination();
                
                // fill the accounts data
                PortalMain.AdminAccountAccessController._populateAccountsTable(data);
                
            }
        );
    },
    
    // populate the accounts table
    _populateAccountsTable: function(accountsData)
    {    
        var accounts = accountsData.data;
        
        // show the table and pagination
        $('#accounts-table').removeClass('hidden');
        $('#accounts-pagination').removeClass('hidden');
        
        // hide the table, and show the error
        if (!accounts.length) {
            $('#no-accounts').removeClass('hidden');
            $('#clear-accounts-success').addClass('hidden');
            $('#accounts-table').addClass('hidden');
            $('#accounts-pagination').addClass('hidden');
        }
        
        // clear the old tickets
        $('#accounts-table tbody tr:not(.clone-source)').remove();
        
        // remove the admin column
        var user = PortalMain.PortalToken.getPayload();
        if (user.uss_admin_level <= 1) {
            $('#accounts-table .admin-column').remove();
        }
        
        // add the new accounts to the DOM
        for (var i in accounts) {
            var account = accounts[i];
            var newEntry = $('#accounts-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the name
            $('.name', newEntry).html(account.name);
            
            // apply the account number
            $('.account-number', newEntry).html(account.account_number);
            
            // apply the account id
            $('.account-id', newEntry).html(account.account_id);
            
            // apply the is active
            if (account.is_active) {
                $('.is-active', newEntry).html('Yes');
            } else {
                $('.is-active', newEntry).html('-');
            }
            
            // set the row account id attribute, and field name
            newEntry.attr('data-account-id', account.account_id);
            newEntry.find('input[type="radio"]').each(function(i, e) {
                $(e).attr('name', 'account-' + account.account_id);
            });
            
            // change the radio to reflect the users permissions
            if (!account.accounts_users.length) {
                newEntry.find('.no-access').prop('checked', true);
            } else if (account.accounts_users[0].is_account_admin) {
                newEntry.find('.admin-access').prop('checked', true);
            } else {
                newEntry.find('.user-access').prop('checked', true);
            }
            
            // add to to the table
            $('#accounts-table tbody').append(newEntry);
        }
        
    },
    
    // send the account permission changes to the API
    _updateAccountPermission: function(accountId, accessLevel)
    {
        // make the request
        var accessRequest = new PortalRequest;
        accessRequest.makeRequest(
            '/admin/add-account',
            {
                accountId: accountId,
                accessLevel: accessLevel
            },
            function() {
                // ensure the login data updates on next page load
                PortalMain.PortalLogin.forceLoginUpdateOnNextLoad();
            }
        );
    },
    
    // clear the account access for the authenticated user
    _clearAccounts: function()
    {
        // make the request
        var accessRequest = new PortalRequest;
        accessRequest.makeRequest(
            '/admin/clear-accounts',
            {},
            function() {
                // ensure the login data updates on next page load
                PortalMain.PortalLogin.forceLoginUpdateOnNextLoad();
                
                $('#clear-accounts-success').removeClass('hidden');
                $('#no-accounts').addClass('hidden');
                $('#accounts-table').addClass('hidden');
                $('#accounts-pagination').addClass('hidden');
            }
        );
    },

}